import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from 'lib/request/api';
import type { TypeCurveListingRow } from 'types/api-responses';

interface TypeCurveHeadersResponse {
  results?: TypeCurveListingRow[];
}

/**
 * The query for a TypeCurve area's active type curves. The area and its type curve
 * area share a name (it is copied onto the type curve area), and the headers search
 * joins on that name, as the type curve area popup's does.
 * @param {string | null} areaName The area's name; null fetches nothing.
 * @return {object} The query's options.
 */
const typeCurveLinksQuery = (areaName: string | null) =>
  queryOptions({
    queryKey: ['area-type-curve-links', areaName],
    queryFn: ({ signal }) =>
      api
        .post('queries/type_curve_headers', {
          json: {
            query: {
              page: 1,
              pageSize: 1000,
              text: '',
              typeCurveAreaName: areaName,
              active: true,
              paginated: false,
              sortAttribute: 'positional_index',
              sortDirection: 'ASC',
            },
          },
          signal,
        })
        .json<TypeCurveHeadersResponse>()
        .then((response) => response.results ?? []),
    enabled: !!areaName,
    staleTime: 60_000,
  });

/**
 * A TypeCurve area's active type curves, for its popup's Associated Links.
 * @param {string | null} areaName The area's name; null fetches nothing.
 * @return {object} React Query result holding the type curves.
 */
export function useTypeCurveLinks(areaName: string | null) {
  return useQuery(typeCurveLinksQuery(areaName));
}
